import { useI18n } from '@design-system/i18n';
export const useScreenReaderStatus = ({ hasNoResult, isFetching, isLoading, itemsSize, noResultsMessage, resultsFoundMessage, }) => {
    const { __, n__ } = useI18n();
    const resultsFoundMessageDefault = (itemsSizeFound) => n__('%{itemsSize} match found', '%{itemsSize} matches found', itemsSizeFound).i__({
        itemsSize: `${itemsSizeFound}`,
    });
    if (isFetching || isLoading) {
        return '';
    }
    if (itemsSize) {
        return resultsFoundMessage
            ? resultsFoundMessage(itemsSize)
            : resultsFoundMessageDefault(itemsSize);
    }
    if (hasNoResult) {
        return noResultsMessage || __('No matches found');
    }
    return null;
};
//# sourceMappingURL=useScreenReaderStatus.js.map